module.exports = __webpack_public_path__ + "static/image_side_right-8e722f2ec2edfc746294bae1f7ff9109.svg";